module.exports = __webpack_public_path__ + "static/media/logo-small2.2471642c.png";